'use client'

import { getProfileMetaContextHeaders } from '@entities/users/apis/meta-profile-context'
import { getQueryClient } from '@shared/apis/tanstack-query/query-client'
import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

/** Observe each landing before a later conversion; collection remains fail-closed until KR is known. */
export function MetaContextObserver({ bearerToken }: { bearerToken?: string }) {
  const pathname = usePathname()
  const search = useSearchParams()
  useEffect(() => {
    if (!bearerToken) {
      return
    }
    const observe = () => {
      getProfileMetaContextHeaders(bearerToken)
    }
    observe()
    // Hydration may populate the profile after this effect. Read the exact token key on every update.
    return getQueryClient().getQueryCache().subscribe(observe)
  }, [pathname, search, bearerToken])
  return null
}
